import * as z from 'zod';

var Metadata;
(function (Metadata) {
    Metadata.schema = z.object({});
})(Metadata || (Metadata = {}));

export { Metadata };
